'use strict';

var $ = require('jquery');
var Backbone = require('backbone');

export default Backbone.View.extend({

  tagName: 'input',

  attributes: {
    type: 'checkbox',
  },

  initialize: function (options) {
    this.name = options.name;
    this.option = options.option;
    this.checked = options.checked;

    this.text = this.option.text;
  },

  render: function () {
    this.$el.attr('id', 'check-' + this.name + '-' + this.option.value);
    this.$el.prop('name', this.name + '[]');
    this.$el.prop('value', this.option.value);

    this.$el.prop('checked', this.checked);

    if (this.required) {
      this.$el.prop('required', true);
    }

    return this;
  },
});
